import './style.css'

import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import pinia from './utils/pinia'

const app = createApp(App)


// if (import.meta.env.PROD) {
//   setInterval(() => {
//     fetch('/version.json', { cache: 'no-cache' })
//       .then(res => res.json())
//       .then(data => {
//         const currentVersion = localStorage.getItem('app_version')
//         if (currentVersion && currentVersion !== data.version) {
//           if (confirm('Versi baru tersedia. Muat ulang sekarang?')) {
//             location.reload(true)
//           }
//         }
//         localStorage.setItem('app_version', data.version)
//       })
//       .catch(() => { })
//   }, 60000)
// }

// app.mount('#app');
// document.getElementById('loading')?.remove();

app.use(pinia)
app.use(router)

router.isReady().then(() => {
  app.mount('#app');
  document.getElementById('loading')?.remove();
});